export const capitalize = (s) => {
   return s
  }